module.exports = __webpack_public_path__ + "media/Components/fonts/fontello-acf6ba4569e6586a8baa3fc0d76781a0.ttf";